import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { Tooltip } from 'react-tooltip';
import { AppWrap, MotionWrap } from '../../wrapper';
import { urlFor, client } from '../../client';
import './Skills.scss';

const Skills = () => {
  const [skills, setSkills] = useState([]);
  const [experiences, setExperiences] = useState([]);
  const [selectedWork, setSelectedWork] = useState(null);

  useEffect(() => {
    const experienceQuery = '*[_type=="experiences"]';
    const skillsQuery = '*[_type=="skills"]';

    client.fetch(skillsQuery).then((data) => {
      setSkills(data);
    });

    client.fetch(experienceQuery).then((data) => {
      // Sort experiences to prioritize "QA Intern" at the top
      const sortedExperiences = data.map(exp => ({
        ...exp,
        works: exp.works.sort((a, b) => {
          if (a.name === 'QA Intern') return -1;
          if (b.name === 'QA Intern') return 1;
          return 0;
        })
      }));
      setExperiences(sortedExperiences);
    });
  }, []);

  const handleWorkClick = (work) => {
    setSelectedWork(work);
  };

  const closeModal = () => {
    setSelectedWork(null);
  };

  return (
    <>
      <h2 className="head-text">Skills & Experience</h2>

      <div className="app_skills-container">
        {/* Skills List */}
        <motion.div className="app_skills-list">
          {skills.map((skill) => (
            <motion.div
              whileInView={{ opacity: [0, 1] }}
              transition={{ duration: 0.5 }}
              className="app_skills-item app_flex"
              key={skill.name}
            >
              <div
                className="app_flex"
                style={{ backgroundColor: skill.bgColor }}
              >
                <img src={urlFor(skill.icon)} alt={skill.name} />
              </div>
              <p className="p-text">{skill.name}</p>
            </motion.div>
          ))}
        </motion.div>

        {/* Experience List */}
        <motion.div className="app_skill-exp">
          {experiences.map((item) => (
            <motion.div className="app_skills-exp-item" key={item.year}>
              <div className="app_skills-exp-year">
                <p className="bold-text">{item.year}</p>
              </div>
              <motion.div className="app_skills-exp-works">
                {item.works.map((work) => (
                  <React.Fragment key={work.name}>
                    <motion.div
                      whileInView={{ opacity: [0, 1] }}
                      transition={{ duration: 0.5 }}
                      className="app_skills-exp-work"
                      data-tooltip-id={work.name}
                      data-tooltip-content={work.desc}
                      onClick={() => handleWorkClick(work)}
                    >
                      <h4 className="bold-text">{work.name}</h4>
                      <p className="p-text">{work.company}</p>
                    </motion.div>
                    <Tooltip id={work.name} className="skills-tooltip" />
                  </React.Fragment>
                ))}
              </motion.div>
            </motion.div>
          ))}
        </motion.div>
      </div>

      {selectedWork && (
        <div className="app_experience-modal">
          <div className="app_experience-modal-content">
            <span className="close-button" onClick={closeModal}>
              ×
            </span>
            <h3 className="bold-text">Experience Details</h3>
            <div className="app_experience-item">
              <h4 className="bold-text">{selectedWork.name}</h4>
              <p className="p-text">{selectedWork.company}</p>
              <p className="p-text">{selectedWork.desc}</p>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default AppWrap(
  MotionWrap(Skills, 'app_skills'),
  'Skills',
  'app_whitebg'
);